/* jshint ignore:start */

var MaquetaManager = (function($) {
    // console.log("llamada a config idioma");
    var instance;

    function init() {

        var _$maquetaPage;


        function iniciandoFlickity() {
            console.log('MAQUETA WEB....... iniciandoFlickity');

            
            $(".js-flickity-flip").flickity({
                pageDots: false,
                imagesLoaded: true,
                
            });

            $(".js-flickity-info").flickity({
                pageDots: false,
                wrapAround: true,
                draggable: true,
                autoPlay: true,
            });

            $(".js-flickity-basic").flickity({
                pageDots: false,
                adaptiveHeight: true
            });

            $(".js-flickity-curved").flickity({
                pageDots: false,
                adaptiveHeight: true,
                wrapAround: true
            });
        }

        function iniciandoProgressBar() {
            console.log('MAQUETA WEB....... iniciandoProgressBar');
            

            // PROGRESS BAR

            var offsetTop = $('#progressnumber').offset().top;

            $(window).scroll(function() {
                var height = $(window).height();
                if($(window).scrollTop()+height > offsetTop) {
                    jQuery('.progressnumber__center-container').each(function(){
                        jQuery(this).find('.progressnumber__bar').animate({
                            width:jQuery(this).attr('data-percent')
                        },3000);
                    });
                }
            });
        
            // PROGRESS NUMBER

            var a = 0;
            $(window).scroll(function () {
                var oTop = $(".counter-box").offset().top - window.innerHeight;
                if (a == 0 && $(window).scrollTop() > oTop) {
                    $(".counter").each(function () {
                        var $this = $(this),
                            countTo = $this.attr("data-number");
                        $({
                            countNum: $this.text()
                        }).animate(
                            {
                                countNum: countTo
                            },

                            {
                                duration: 2500,
                                easing: "swing",
                                step: function () {
                                    $this.text(
                                        Math.ceil(this.countNum).toLocaleString("en")
                                    );
                                },
                                complete: function () {
                                    $this.text(
                                        Math.ceil(this.countNum).toLocaleString("en")
                                    );
                                }
                            }
                        );
                    });
                    a = 1;
                }
            });

        }

        function iniciandoTimeline() {
            console.log('MAQUETA WEB....... iniciandoTimeline');

            var items = $(".timeline li"),
            timelineHeight = $(".timeline ul").height(),
            greyLine = $('.default-line'),
            lineToDraw = $('.draw-line');


            if(lineToDraw.length) {
                $(window).on('scroll', function () {

                    var redLineHeight = lineToDraw.height(),
                    greyLineHeight = greyLine.height(),
                    windowDistance = $(window).scrollTop(),
                    windowHeight = $(window).height() / 2,
                    timelineDistance = $(".timeline").offset().top;

                    if(windowDistance >= timelineDistance - windowHeight) {
                    line = windowDistance - timelineDistance + windowHeight;

                    if(line <= greyLineHeight) {
                        lineToDraw.css({
                        'height' : line + 20 + 'px'
                        });
                    }
                    }

                    var bottom = lineToDraw.offset().top + lineToDraw.outerHeight(true);
                    items.each(function(index){
                    var circlePosition = $(this).offset();

                    if(bottom > circlePosition.top) {				
                        $(this).addClass('in-view');
                    } else {
                        $(this).removeClass('in-view');
                    }
                    });	
                });
            }

                   
        }

        function iniciandoAccordion() {
            console.log('MAQUETA WEB....... iniciandoAccordion');

            $(".accordion__element-option").click(function(e) {

                e.preventDefault();
                var offset = 200;
                var delay = 500;
                var $this = $(this);
                if ($this.next().hasClass("showing")) {
                  $this
                    .next()
                    .removeClass("showing")
                    .slideUp(delay);
                } else {
                  $this
                    .parent()
                    .parent()
                    .find("li .accordion__element-content")
                    .removeClass("showing")
                    .slideUp(delay);
                    
                  $this
                    .next()
                    .toggleClass("showing")
                    .slideToggle(delay, function() {
                      $("html,body").animate(
                        {
                          scrollTop: $(this).parent().find("a").offset().top - offset
                        },
                        delay
                      );
                    });
                }
            });   

            
            $('.js-open-search').click(function() {
                $('.header__search').addClass('show');
            });

            $('.js-close-search').click(function() {
                $('.header__search').removeClass('show');
            });




            Flickity.createMethods.push('_createPrevNextCells');

Flickity.prototype._createPrevNextCells = function() {
  this.on( 'select', this.setPrevNextCells );
};

Flickity.prototype.setPrevNextCells = function() {
  // remove classes
  changeSlideClasses( this.previousSlide, 'remove', 'is-previous' );
  changeSlideClasses( this.nextSlide, 'remove', 'is-next' );
  // set slides
  var previousI = fizzyUIUtils.modulo( this.selectedIndex - 2, this.slides.length );
  var nextI = fizzyUIUtils.modulo( this.selectedIndex + 3, this.slides.length );
  this.previousSlide = this.slides[ previousI ];
  this.nextSlide = this.slides[ nextI ];
  // add classes
  changeSlideClasses( this.previousSlide, 'add', 'is-previous' );
  changeSlideClasses( this.nextSlide, 'add', 'is-next' );
};

function changeSlideClasses( slide, method, className ) {
  if ( !slide ) {
    return;
  }
  slide.getCellElements().forEach( function( cellElem ) {
    cellElem.classList[ method ]( className );
  });
}
        }

        function iniciandoDropdown() {
            console.log('MAQUETA WEB....... iniciandoDropdown');

            $(document).ready(function(){

                $(".dropdown-menu__navigation-element li").hover(
                 
                function(){
                    $(this).children('ul').slideDown('fast');
                    $(this).toggleClass('selected');
                }, 

                function () {
                    $('ul', this).slideUp('fast');
                    $(this).toggleClass('selected');
                });


                $('.tabs-menu__nav a').click(function() {
            
                    $('.tabs-menu__nav').toggleClass('active');

                    $('.tabs-menu__nav li').toggleClass('show');
                    $(this).parent().toggleClass('show');
        
                    var currentTab = $(this).attr('href');
                    $('.tabs-menu__content > div').toggleClass('show');
                    $(currentTab).toggleClass('show');
        
                    return false;
                    });
                });


               


                // scrollmagic

                TweenLite.defaultEase = Linear.easeNone;
                var ctrl = new ScrollMagic.Controller();

                // Create scenes
                $(".scrollmagic__zoom").each(function(i) {
                    var target1 = $(this).find(".scrollmagic__zoom-box1");
                    var tl = new TimelineMax();

                        tl.to(target1, 1, {width: "100%", height: "700px", borderRadius:"0px"}, 0.5);
                      
                        new ScrollMagic.Scene({
                            triggerElement: this,
                            duration: 250,
                            triggerHook: 0.5
                        })

                        .setTween(tl)
                        .addTo(ctrl)
                    });

                    $(".scrollmagic__zoom").each(function(i) {
                        var target2 = $(this).find(".scrollmagic__zoom-box2");
                        var tl = new TimelineMax();
    
                        tl.to(target2, 1, {width: "100%", height: "700px", marginBottom: "-1400px", marginLeft: "-180%"}, 0.5);
                        
                        new ScrollMagic.Scene({
                            triggerElement: this,
                            duration: 250,
                            triggerHook: 0.5
                        })

                        .setTween(tl)
                        .addTo(ctrl)
                    });

                
                    $(".scrollmagic__zoom").each(function(i) {
                        var target3 = $(this).find(".scrollmagic__zoom-box3");
                        var tl = new TimelineMax();
    
                        tl.to(target3, 1, {transform: "scale(1)", opacity: "1"}, 2);
                        
                        new ScrollMagic.Scene({
                            triggerElement: this,
                            duration: 250,
                            triggerHook: 0.5
                        })

                        .setTween(tl)
                        .addTo(ctrl)
                    });
                  
                    $(".scrollmagic__zoom").each(function(i) {
                        var target5 = $(this).find(".scrollmagic__zoom-layer");
                        var tl = new TimelineMax();
    
                        tl.to(target5, 1, {opacity: "0"});
                        
                        new ScrollMagic.Scene({
                            triggerElement: this,
                            duration: 250,
                            triggerHook: 0.5
                        })
                        .setTween(tl)
                        .addTo(ctrl)
                    });
            
        }

      
       
        function iniciandoMobileMenu() {
            console.log('MAQUETA WEB....... iniciandoMobileMenu');

            

            // Lang selected

            $(".header__mobile-lang ul li a").click(function(e) {
                $('.header__mobile-lang ul li a').removeClass('selected');
                $(this).addClass('selected');
            });

            // OPEN CLOSE MENU

            $(".js-open-menu").click(function(e) {
                $('body').addClass('translate');
            });
            $(".js-close-menu").click(function(e) {
                $('body').removeClass('translate');
            });
        }

        

        return {
            initCommon: function() {
                console.log('MAQUETA WEB initcommon.......');

                iniciandoFlickity();
                iniciandoTimeline();
                iniciandoProgressBar();
                iniciandoAccordion();
                // iniciandoDropdown();
                // iniciandoMobileMenu();

                // iniciandoCarruseles();
            },
            


            init: function() {
                _$maquetaPage = $('.page-template-template-new-web-maqueta');

                if (_$maquetaPage.length) {
                    // console.log('más cursos inittttt');
                    this.initCommon();
                }
            }
        };
    }


    return {

        getInstance: function(){

            if (!instance){
                instance = init();
            }

            return instance;
        }
    };
})(jQuery);
/* jshint ignore:end */




/******** FLIP CAROUSEL *****/


// Flickity.createMethods.push('_createPrevNextCells');

// Flickity.prototype._createPrevNextCells = function() {
//   this.on( 'select', this.setPrevNextCells );
// };

// Flickity.prototype.setPrevNextCells = function() {
//   // remove classes
//   changeSlideClasses( this.previousSlide, 'remove', 'is-previous' );
//   changeSlideClasses( this.nextSlide, 'remove', 'is-next' );
//   // set slides
//   this.previousSlide = this.slides[ this.selectedIndex - 1 ];
//   this.nextSlide = this.slides[ this.selectedIndex + 1 ];
//   // add classes
//   changeSlideClasses( this.previousSlide, 'add', 'is-previous' );
//   changeSlideClasses( this.nextSlide, 'add', 'is-next' );
// };

// function changeSlideClasses( slide, method, className ) {
//   if ( !slide ) {
//     return;
//   }
//   slide.getCellElements().forEach( function( cellElem ) {
//     cellElem.classList[ method ]( className );
//   });
// }